import React from 'react';
import { HtmlTitle } from '../html';
import { ModuleBreadcrumbs } from './header/breadcrumbs/ModuleBreadcrumbs';
import { PageBreadcrumbs } from './header/breadcrumbs/PageBreadcrumbs';
import { PageHeader } from './header/PageHeader';
import { PageContent } from './PageContent';

interface Props {
  readonly footer?: React.ReactNode;
  readonly htmlTitle?: string | string[];
  readonly children: React.ReactNode;
}

/** Main Page component that wraps content with layout. Header is any children before the first Page.Content. */
export function Page(props: Props) {
  const { htmlTitle, children } = props;

  return (
    <>
      {htmlTitle && <HtmlTitle text={htmlTitle} />}
      {children}
    </>
  );
}

Page.Content = PageContent;
Page.ModuleBreadcrumbs = ModuleBreadcrumbs;
Page.Header = PageHeader;
Page.Breadcrumbs = PageBreadcrumbs;
